<template>
	<footer class="footer mt-auto py-6">
		<div class="container">
			<common-message-powered />
		</div>
	</footer>
</template>